export default __webpack_public_path__ + "static/media/home_kategori.437d58c0.svg";